// extracted by mini-css-extract-plugin
export default {"container":"roomsPage_container__PmvSC","price":"roomsPage_price__clAQo"};